import * as qs from 'querystring';

import { AppViewLinkState } from '../appview/lib/types';
import { domainConfig } from './domainConfig';

export const Colors = {
  lightGrayBackground: '#f3f3f2',
};

export const Links = {
  instagram: 'https://www.instagram.com/fi.dogs/',
  facebook: 'https://www.facebook.com/dogcollarsbyfi/',
  twitter: 'https://twitter.com/fidogtweets',
  pinterest: 'https://www.pinterest.com/fidogs/',
  blog: domainConfig.blogUrl,
  faq: domainConfig.supportUrl,
  contact: domainConfig.contactUrl,
  accessories: domainConfig.accessoriesUrl,
  shop: domainConfig.shopUrl,
  marketingSite: domainConfig.marketingSite,

  stories: domainConfig.storiesUrl,
  tech: domainConfig.techUrl,
  collar: domainConfig.collarUrl,
  app: domainConfig.appUrl,
  reviews: domainConfig.reviewsUrl,

  iosAppStore: `https://itunes.apple.com/us/app/fi-gps-dog-tracker/id1438036784?ls=1&mt=8`,
  androidAppStore: `https://play.google.com/store/apps/details?id=com.barkinglabs.fi`,

  login: (redirectUri?: string) => `/login?${qs.stringify({ redirectUri })}`,
  scanChip: `fi://scanchip`,
  closeAppView: () => `fi://closeappview`,

  resellerChipDetails(id: string, state: AppViewLinkState, isDesktop: boolean) {
    return {
      pathname: isDesktop ? '/vet/chip' : '/appview/resellerchipdetails',
      search: `?${qs.stringify({ id })}`,
      state,
    };
  },
  listChips: () => `/appview/listchips`,
  vetChipList: () => `/vet/chips`,
  vetChip: (id: string) => `/vet/chip?id=${encodeURIComponent(id)}`,
  manageAccount: () => `/vet/account`,

  sendFiNanoToYourVet: `mailto:?${qs.stringify({
    subject: `Fi Nano`,
    body: `Hi,\n\nI would love for you to look at the Fi Nano microchip. You can find more information at https://${domainConfig.siteDomain}.`,
  })}`,

  manageChipDetails: (params: { id: string }) => `/manage/chipdetails?${qs.stringify(params)}`,
  manageHome: `/manage`,

  register: (params: { id?: string; petId?: string } = {}) => `/register?${qs.stringify(params)}`,

  search: (query?: string) => `/verifysearch?q=${query}`,
};

export const NavLinks = [
  { path: Links.tech, text: 'How it Works' },
  { path: Links.register(), text: 'Register Chip' },
  { path: Links.collar, text: 'The Collar' },
  { path: Links.reviews, text: 'Reviews' },
  { path: Links.stories, text: 'Stories' },
  { path: Links.blog, text: 'Off Leash' },
];

export const apiHost = (import.meta as any).env?.VITE_API_HOST;

export const AAHASearchUrl = (serialNumber?: string) =>
  `https://www.aaha.org/for-veterinary-professionals/microchip-registry-lookup-tool-aaha-find-your-pets-microchip-registry/?microchip_id=${
    serialNumber ?? ''
  }`;
